// extracted by mini-css-extract-plugin
module.exports = {"dropdown-action-cell":"templateRow_dropdown-action-cell__28SFD","icon-action-cell":"templateRow_icon-action-cell__3mLLl"};